import '../src/javascript/legal_signup';
